import { render, staticRenderFns } from "./groupCustomer_item_info.vue?vue&type=template&id=af728c68"
import script from "./groupCustomer_item_info.vue?vue&type=script&lang=js"
export * from "./groupCustomer_item_info.vue?vue&type=script&lang=js"
import style0 from "./groupCustomer_item_info.vue?vue&type=style&index=0&id=af728c68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports